import { Styles, css } from '@flipster/styled-system/css';

export interface SeparatorProps {
  css?: Styles;
}

export const HSeparator = ({ css: cssProp }: SeparatorProps) => {
  return (
    <div
      role='separator'
      className={css(
        {
          h: 1,
          alignSelf: 'stretch',
          background:
            'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, {colors.border.default.level-4} 50%, rgba(255, 255, 255, 0) 100%)',
        },
        cssProp,
      )}
    />
  );
};

export const VSeparator = ({ css: cssProp }: SeparatorProps) => {
  return (
    <div
      role='separator'
      className={css(
        {
          w: 1,
          background:
            'linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, {colors.border.default.level-4} 50%, rgba(255, 255, 255, 0) 100%)',
        },
        cssProp,
      )}
    />
  );
};
